import { z } from "zod";

export const notificationTypeUpdateSchema = z.object({
  titulo: z.string().trim().min(1, "Campo requerido").max(36, "Máximo 36 caracteres"),
  cuerpo: z
    .string()
    .trim()
    .min(1, "Campo requerido")
    .max(80, "Máximo 80 caracteres"),
});
